export default "__VITE_ASSET__DyassgTi__"